import { render, staticRenderFns } from "./RejectLeaveModal.vue?vue&type=template&id=32717f56&"
import script from "./RejectLeaveModal.vue?vue&type=script&lang=js&"
export * from "./RejectLeaveModal.vue?vue&type=script&lang=js&"
import style0 from "./RejectLeaveModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports